// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8676dde3","453":"32f6cc1d","455":"22e01a6c"}[chunkId] + ".chunk.js";
};